const domain_regex = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z]/g;
const ip_regex = /\b(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])(?:\.|\[\.\]|\(\.\)|\{\.\})){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\b/g;

module.exports = {
  
  // input is a string of the file content
  analyze( input ) {
    const results = { domains: [...input.matchAll(domain_regex)], ips: [...input.matchAll(ip_regex)] }
    return results
  },

  analyze_ip( input ) {
    let results = [...input.matchAll(ip_regex)]

    let defanged = new Set([])
    for (let i=0; i<results.length;i++) {
      defanged.add(results[i][0].replace(/[\[\]\(\)\{\}]/g, ""))
    }

    return {
      orig_count: results.length,
      ips: [...defanged]
    }
  },

  analyze_domain( input ) {
    let lower = input.toLowerCase()
    let results = [...lower.matchAll(domain_regex)]

    let unique = new Set([])
    for (let i = 0; i < results.length; i++) {
      unique.add(results[i][0])
    }

    return {
      orig_count: results.length,
      domains: [...unique]
    }
  },

}
